import axios from '@axios'

export default {
    namespaced: true,
    state: {
        notificationsCount: 0,
        notifications: [],
    },
    getters: {
        getNotifications: state => state.notifications,
        getNotificationsCount: state => state.notificationsCount,
    },
    mutations: {
        SET_NOTIFICATIONS(state, notifications) {
            state.notifications = notifications
        },
        SET_NOTIFICATIONS_COUNT(state, notificationsCount) {
            state.notificationsCount = notificationsCount
        },
    },
    actions: {
        forgotPassword({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/forgot-password', payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        resetPassword({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/reset-password', payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        checkReset({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/reset-check', payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        updateProfile({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/update-profile', payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        updatePassword({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/auth-reset-password', payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        updateConfig({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/save-configuration', payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        saveWebPushToken({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/web-push/token', payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        deleteWebPushToken({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .delete('/api/auth/web-push/token', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchWebNotifications({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/web-push/notifications', { params })
                    .then(response => {
                        commit('SET_NOTIFICATIONS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchWebNotificationsCount({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/web-push/notifications', { params })
                    .then(response => {
                        commit('SET_NOTIFICATIONS_COUNT', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        discardWebNotifications({ commit }, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .patch('/api/auth/web-push/notifications', payload)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
